

import initialState from './initialState';

export default function statsReducer(state = initialState.stats, action) {
  //let newState;

  switch (action.type) {

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/statsReducer.js